import { TRIAL_PERIOD_DAYS } from '@aloft/toolkit-shared';
import { Flex, Typography } from '@aloft/toolkit-sui';

import { getPlan } from '../../utils/getPlan.ts';
import { CheckoutProps } from './types.ts';

type Props = {
  priceID: CheckoutProps['priceID'];
  isTrial: boolean;
};

export function ProductInfo({ priceID, isTrial }: Props) {
  const { price, interval } = getPlan(priceID);
  const formattedPrice = price.toAbbrString(0);

  if (isTrial) {
    return (
      <>
        <Flex flexDirection="column">
          <Typography variant="displaySmall">
            {TRIAL_PERIOD_DAYS.toLocaleString()} days free
          </Typography>
          <Typography variant="h3" color="textTertiary">
            Then {formattedPrice} per {interval}
          </Typography>
        </Flex>
      </>
    );
  }

  return (
    <>
      <Flex gap="4px" alignItems="baseline">
        <Typography variant="displaySmall">{formattedPrice}</Typography>
        <Typography variant="h3" color="textTertiary">
          per {interval}
        </Typography>
      </Flex>
    </>
  );
}
